import React, { useEffect, useRef, useState } from "react";
import { Card, Button, Spin, Typography } from "antd";
import { ArrowLeftOutlined, PrinterOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import { useReactToPrint } from "react-to-print";

import ReportDom from "../../../../../components/common/ReportDom";
import { getInstitutionApi } from "../../../../../apiservice/setting";
import ServiceVoucherBody from "../../ServiceVoucher/components/ServiceVoucherBody";
import ServiceVoucherBodyDesignA from "../../ServiceVoucher/components/ServiceVoucherBodyDesignA";
import Swal from "sweetalert2";
import { useShareDocument } from "../../../../../hooks/useShareDocument";
import ShareDocumentButton from "../../../../../components/ShareButton/ShareDocumentButton";

const { Text } = Typography;

const QuickServiceVoucher = () => {
  const { id } = useParams(); // service_id from URL
  const navigate = useNavigate();
  const reportRef = useRef(null);

  const [institution, setInstitution] = useState(null);
  const [loading, setLoading] = useState(true);
  const [voucherNo, setVoucherNo] = useState("");
  const [accName, setAccName] = useState("");
  const [customerEmail, setCustomerEmail] = useState("");

  const {
    shareOpen,
    setShareOpen,
    email,
    setEmail,
    handleEmailShare,
    handleWhatsAppShare,
  } = useShareDocument();

  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "Service Voucher",
    removeAfterPrint: true,
  });

  useEffect(() => {
    const fetchInst = async () => {
      try {
        const res = await getInstitutionApi();
        setInstitution(res.data);
      } catch (err) {
        Swal.fire("Error", err.response?.data?.message || "Institution fetch error", "warning");
      } finally {
        setLoading(false);
      }
    };

    fetchInst();
  }, []);

  useEffect(() => {
    if (shareOpen && customerEmail) {
      setEmail(customerEmail);
    }
  }, [shareOpen, customerEmail, setEmail]);

  return (
    <div className="p-4">
      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 16 }}>
        <Button icon={<ArrowLeftOutlined />} onClick={() => navigate(-1)}>
          Back
        </Button>

        <div style={{ display: "flex", gap: 8 }}>
          <ShareDocumentButton
            disabled={loading || !id}
            shareOpen={shareOpen}
            setShareOpen={setShareOpen}
            email={email}
            setEmail={setEmail}
            loading={loading}
            onEmail={() =>
              handleEmailShare({
                url: `/print/service/${id}`,
                fileName: `Service_${
                  voucherNo || "Voucher"
                }.pdf`,
                name: accName || "",
                docNo: voucherNo || "Voucher",
              })
            }
            onWhatsApp={() =>
              handleWhatsAppShare({
                url: `/print/service/${id}`,
                fileName: `Service_${
                  voucherNo || "Voucher"
                }.pdf`,
                text: `Hello ${accName || ""}, Your Service Voucher ${
                  voucherNo || "Voucher"
                } is ready. Download here:`,
              })
            }
          />

          <Button
            type="primary"
            icon={<PrinterOutlined />}
            onClick={handlePrint}
            disabled={loading || !id}
          >
            Print
          </Button>
        </div>
      </div>

      {/* Voucher Body */}
      <Card className="shadow-md rounded-xl">
        {loading ? (
          <div style={{ textAlign: "center", padding: "40px 0" }}>
            <Spin />
          </div>
        ) : id ? (
          <ServiceVoucherBody
            service_id={id}
            institution={institution}
            setVoucherNo={setVoucherNo}
            setAccName={setAccName}
            setCustomerEmail={setCustomerEmail}
          />
        ) : (
          <Text type="secondary">Invalid voucher ID</Text>
        )}
      </Card>

      {/* Hidden print layout */}
      {id && (
        <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
          <ReportDom
            ref={reportRef}
            mode={institution?.print_template === "design_a" ? "no-title" : undefined}
            // title="Service Voucher"
            renderTable={() =>
              institution?.print_template === "design_a" ? (
                <ServiceVoucherBodyDesignA service_id={id} />
              ) : (
                <ServiceVoucherBody service_id={id} institution={institution} printMode />
              )
            }
          />
        </div>
      )}
    </div>
  );
};

export default QuickServiceVoucher;
